export default "__VITE_ASSET__CbA2ps$r__"